import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3408b139&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3408b139')) {
      api.createRecord('3408b139', component.options)
    } else {
      api.reload('3408b139', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3408b139&", function () {
      api.rerender('3408b139', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/result/src/index.vue"
export default component.exports